module.exports = __webpack_public_path__ + "static/media/userGuide.5062cb4e.png";